import type { Account } from '@shared/products-types';
import type { ProductWithHelpers } from '@shared/products-core';

export function getAccount(
    products: Array<ProductWithHelpers<Account>>,
    ownerId: string,
): ProductWithHelpers<Account> | undefined {
    return products.find(({ id }) => id === ownerId);
}

export function getCardFromProduct(account: ProductWithHelpers<Account>) {
    return account.card;
}

export function getTransactionAccount(
    products: Array<ProductWithHelpers<Account>>,
    ownerId: string,
): ProductWithHelpers<Account> | undefined {
    return products.find(({ transactionAccountId }) => transactionAccountId === ownerId);
}
